import decoder from '../../../lib/decoder';

function ModelVats() {
	this.id = 0;
	this.billingId = 0;
	this.name = '';
	this.anchor = '';
	this.limit = 0;
	this.connectedCount = 0;
	this.price = 0;
	this.isDemo = false;
}

ModelVats.create = function (json) {
	if (!json) json = {};
	
	let model = new ModelVats();
	
	if (Object.hasOwnProperty.call(json, 'BILLING_ID')) {
		model.billingId = decoder.intValue(json['BILLING_ID'], 0);
	}
	
	if (Object.hasOwnProperty.call(json, 'VAST_NAME')) {
		model.name = decoder.stringValue(json['VAST_NAME'], '');
	} else if (Object.hasOwnProperty.call(json, 'VERSION')) {
		model.name = decoder.stringValue(json['VERSION'], '');
	}
	
	if (Object.hasOwnProperty.call(json, 'VAST_ANCHOR')) {
		model.anchor = decoder.stringValue(json['VAST_ANCHOR'], '');
	} else if (Object.hasOwnProperty.call(json, 'ANCHOR')) {
		model.anchor = decoder.stringValue(json['ANCHOR'], '');
	}
	
	if (Object.hasOwnProperty.call(json, 'NUMBER_LIMITS')) {
		model.limit = decoder.intValue(json['NUMBER_LIMITS'], 0);
	} else if (Object.hasOwnProperty.call(json, 'LIMIT')) {
		model.limit = decoder.intValue(json['LIMIT'], 0);
	}
	
	if (Object.hasOwnProperty.call(json, 'CONNECTED_NUM_COUNT')) {
		model.connectedCount = decoder.intValue(json['CONNECTED_NUM_COUNT'], 0);
	}
	
	if (Object.hasOwnProperty.call(json, 'PRICE')) {
		let price = json['PRICE'].replace(/\s/g, '');
		model.price = decoder.floatValue(price, 0);
	}
	
	if (Object.hasOwnProperty.call(json, 'IS_DEMO')) {
		model.isDemo = decoder.boolValue(json['IS_DEMO'], false);
	}
	
	return model;
};

export default ModelVats;